module.exports = __webpack_public_path__ + "static/media/springcourt-logo.8321bdf9.svg";